import * as React from "react";

const MED_BREAKPOINT = 768;
const MOBILE_BREAKPOINT = 1024;

interface UseIsMobileReturn {
  readonly isMobile: boolean;
  readonly isMdOrSmaller: boolean;
}

export function useIsMobile(): UseIsMobileReturn {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined);
  const [isMdOrSmaller, setIsMdOrSmaller] = React.useState<boolean | undefined>(undefined);

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    const onMobileChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    };
    mql.addEventListener("change", onMobileChange);
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);

    const mdql = window.matchMedia(`(max-width: ${MED_BREAKPOINT - 1}px)`);
    const onMedChange = () => {
      setIsMdOrSmaller(window.innerWidth < MED_BREAKPOINT);
    };
    mdql.addEventListener("change", onMedChange);
    setIsMdOrSmaller(window.innerWidth < MED_BREAKPOINT);

    return () => {
      mql.removeEventListener("change", onMobileChange);
      mdql.removeEventListener("change", onMedChange);
    };
  }, []);

  return {
    isMobile: !!isMobile,
    isMdOrSmaller: !!isMdOrSmaller,
  };
}
